import { useEffect } from 'react';
import { FRONTEND_CONFIG } from '../../configurations/application_config';

const ExternalRedirect = ({ to, path }) => {
  useEffect(() => {
    const baseUrl = FRONTEND_CONFIG.PUBLIC_NEWS_FEED_URL.replace(/\/$/, '');
    let targetPath = to || path || '';
    
    // Convert all underscores to hyphens for the new project structure
    targetPath = targetPath.replace(/_/g, '-');

    window.location.href = `${baseUrl}${targetPath}${window.location.search}`;
  }, [to, path]);

  return null;
};

export default ExternalRedirect;
